import { CLEAR_PLAYERS_IN_GAME_STATE, UPDATE_GAME_STATE } from "../constants/gameState-types";

const initialState = {
  gameState: {players:[]},
};

export default function gameStateReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_GAME_STATE:
      return {
        ...state,
        gameState: action.gameState,
      };
    case CLEAR_PLAYERS_IN_GAME_STATE:
      return {
        ...state,
        gameState: {
          ...state.gameState,
          players: [],
        }
      }
    default:
      return state;
  }
}
